import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './i18n';
import App from './App';
import { SimpleAuth } from './components/SimpleAuth';
import { LanguageProvider } from './context/LanguageProvider';
import { Toaster } from 'sonner';
import { initializeVersionCheck } from './utils/versionCheck';

function AppWrapper() {
  const [user, setUser] = useState(null);

  // Load user from localStorage on mount
  useEffect(() => {
    const savedUser = localStorage.getItem('qualiz_user');
    if (savedUser) {
      try {
        const userData = JSON.parse(savedUser);
        console.log('Loaded user from localStorage:', userData);
        console.log('User has _id:', !!userData._id);
        setUser(userData);
      } catch (error) {
        console.error('Error parsing saved user:', error);
        localStorage.removeItem('qualiz_user');
      }
    }

    // Initialize version checking
    initializeVersionCheck().catch(error => {
      console.error('Failed to initialize version check:', error);
    });
  }, []);

  const handleLogin = userData => {
    console.log('User logged in:', userData);
    console.log('User ID:', userData._id);

    if (!userData._id) {
      console.warn('Warning: User data does not contain _id field');
    }

    setUser(userData);
    localStorage.setItem('qualiz_user', JSON.stringify(userData));
  };

  const handleLogout = () => {
    console.log('User logged out');
    setUser(null);
    localStorage.removeItem('qualiz_user');
    if (window?.history?.replaceState) {
      window.history.replaceState({}, document.title, '/');
    }
  };

  const handleUpdateUser = updatedUser => {
    console.log('User updated:', updatedUser);
    setUser(updatedUser);
  };

  return (
    <SimpleAuth user={user} onLogin={handleLogin} onLogout={handleLogout}>
      <App user={user} onUpdateUser={handleUpdateUser} />
    </SimpleAuth>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <LanguageProvider>
      <Toaster
        position="top-right"
        expand={false}
        richColors={true}
        closeButton={true}
        duration={3500}
        toastOptions={{
          classNames: {
            toast: 'font-sans',
            title: 'text-sm font-semibold',
            description: 'text-sm',
          },
        }}
      />
      <AppWrapper />
    </LanguageProvider>
  </React.StrictMode>
);
